import { Plane, useTexture } from "@react-three/drei";
import useThreeJsLoader from "../../../zustand/stores/useThreeJsLoader";
import { useEffect, useRef, useState } from "react";
import MoldingsManager from "./MoldingsManager";
import * as THREE from "three";

const Painting = (props) => {
  const [texture] = useTexture([props.imgUrl]);

  const setNormalize = useThreeJsLoader((state) => state.setNormalize);

  const [moldingType, setMoldingType] = useState({
    type: null,
    url: "",
  });

  const moldingRef = useRef();
  const aspectRatioRef = useRef();
  const imageRef = useRef();
  const moldingLandscapeRef = useRef(null);

  useEffect(() => {
    let imageWidth = texture.source.data.width;

    let imageHeight = texture.source.data.height;

    if (moldingLandscapeRef.current !== moldingType.url) {
      if (moldingType.type === "square") {
        aspectRatioRef.current = 1;
        imageRef.current.scale.set(1, 1, 1);
      } else if (moldingType.type === "landscape") {
        aspectRatioRef.current = imageWidth / imageHeight;
        imageRef.current.scale.set(1, 1 / aspectRatioRef.current, 1);
      } else {
        aspectRatioRef.current = imageHeight / imageWidth;
        imageRef.current.scale.set(1, aspectRatioRef.current, 1);
      }
    }
    moldingLandscapeRef.current = moldingType.url;
    setNormalize();
  }, [moldingType.url]);

  useEffect(() => {
    let imageWidth = texture.source.data.width;
    let imageHeight = texture.source.data.height;
    imageRef.current.material.alphaTest = 0.9;
    if (imageWidth === imageHeight) {
      aspectRatioRef.current = 1;
      setMoldingType({ type: "square", url: props.imgUrl });
    } else if (imageWidth > imageHeight) {
      setMoldingType({ type: "landscape", url: props.imgUrl });
    } else if (imageHeight > imageWidth) {
      setMoldingType({ type: "portrait", url: props.imgUrl });
    }
  }, [texture, imageRef.current]);

  return (
    <>
      {/* Molding content */}
      <Plane args={[1, 1]} ref={imageRef}>
        <meshBasicMaterial map={texture} side={THREE.DoubleSide} />
        <MoldingsManager
          ref={moldingRef}
          type={moldingType.type}
          molding={props.molding}
        />
      </Plane>
    </>
  );
};

export default Painting;
